import {getConfigItem, configConstants, observeConfigItem} from '@servicenow/ui-config';
import {createInteractionId} from '@servicenow/ui-metrics';
import deferHelperExecution from './deferHelperExecution';
import {LoggerProvider} from '@devsnc/sn-ui-logger';

globalThis.nowUiFramework = globalThis.nowUiFramework || {};
const {LOGGING_ENABLED, LOGGING_LEVELS} = configConstants;
const globalLoggerProvider = getLoggerProvider();
if (!getConfigItem(LOGGING_ENABLED)) globalLoggerProvider.disableLogging();

const loggerFunctions = globalThis.nowUiFrameworkLogs.logTypes;
const observer = (path, value) => {
	switch (path) {
		case LOGGING_ENABLED:
			if (value) globalLoggerProvider.enableLogging();
			else globalLoggerProvider.disableLogging();
			break;
		case LOGGING_LEVELS:
			globalLoggerProvider.logLevel = value;
			break;
	}
};

observeConfigItem(LOGGING_ENABLED, observer);
observeConfigItem(LOGGING_LEVELS, observer);

export function getLoggerProvider() {
	const globalLoggerProvider = globalThis.nowUiFramework.snUiLoggerProvider;
	if (globalLoggerProvider) {
		return globalLoggerProvider;
	}

	const {LOGGING_LEVELS, LOGS_OBSERVER_INTERVAL, LOGS_CLEANUP_INTERVAL, LOG_EXPORTER} =
		configConstants;

	globalThis.nowUiFramework.snUiLoggerProvider = new LoggerProvider({
		collectTimeInterval: getConfigItem(LOGS_OBSERVER_INTERVAL),
		cleanupTimeInterval: getConfigItem(LOGS_CLEANUP_INTERVAL),
		logLevel: getConfigItem(LOGGING_LEVELS),
		exporter: getConfigItem(LOG_EXPORTER)
	});
	return globalThis.nowUiFramework.snUiLoggerProvider;
}

export function getComponentLogger(host) {
	const logger = {};

	const globalLoggerProvider = globalThis.nowUiFramework.snUiLoggerProvider;
	if (!globalLoggerProvider) return logger;

	return globalLoggerProvider.getLogger(host.tagName.toLowerCase());
}

export function setLogContext({traceId = createInteractionId(), spanId}) {
	const globalLoggerProvider = globalThis.nowUiFramework.snUiLoggerProvider;
	if (globalLoggerProvider) globalLoggerProvider.context = {traceId, spanId};
}

export default function createComponentLogger(host, executionTiming) {
	const logger = {};
	loggerFunctions.forEach(loggerFn => {
		logger[loggerFn] = function logFn(...args) {
			deferHelperExecution(
				executionTiming,
				() => {
					const loggerClass = getComponentLogger(host);
					if (loggerClass[loggerFn] && typeof loggerClass[loggerFn] === 'function')
						loggerClass[loggerFn](...args);
					else if (loggerClass?.info) loggerClass.info(...args);
				},
				{el: host}
			);
		};
	});
	return logger;
}
